var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2226 6.27258C16.7398 6.99738 16.7398 9.15703 15.2226 9.88183L2.8622 15.787C1.5348 16.4212 4.69089e-05 15.4535 4.69089e-05 13.9824V2.17202C4.69089e-05 0.700913 1.5348 -0.266772 2.8622 0.367393L15.2226 6.27258Z",
    fill: "#495376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBg);
export default __webpack_public_path__ + "static/media/chevron_right_bg.e23cc0201c9b237a8d65b8d5faf364b6.svg";
export { ForwardRef as ReactComponent };